<template>
  <div>
    <div class="collapsed" @click="toggleCollapsed(!collapsed)">
      <img v-show="collapsed" src="@/assets/icons/icon_zk@2x.png" alt="" />
      <img v-show="!collapsed" src="@/assets/icons/icon_sq@2x.png" alt="" />
    </div>
    <!-- <a-button type="primary" class="collapsed" @click="toggleCollapsed(!collapsed)">
      <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
    </a-button> -->
    <div v-if="isAdmin" :class="['admin-menu', collapsed ? 'menu-collapsed' : '']">
      <div class="logo">
        <img src="@/assets/logo_2@2x.png" alt="" srcset="" />
      </div>
      <div class="menu">
        <a-menu
          :selectedKeys="defaultSelectedKeys"
          :open-keys="openKeys"
          mode="inline"
          theme="dark"
          @openChange="onOpenChange"
          :inline-collapsed="collapsed"
        >
          <template v-for="menu in adminMenu">
            <template v-if="menu.child.length">
              <a-sub-menu v-if="!menu.hidden" :key="menu.name">
                <span class="icon-admin-cover" slot="title">
                  <img class="icon-admin" :src="menu.checked ? menu.icon1 : menu.icon0" />
                  <span v-if="!collapsed">{{ menu.name }}</span>
                </span>
                <template v-for="childMenu in menu.child">
                  <a-menu-item
                    v-if="
                      !childMenu.hidden && (!childMenu.child || childMenu.child.length === 0) && childMenu.id !== '6-2'
                    "
                    :key="childMenu.name"
                    @click="handleClick(childMenu)"
                  >
                    {{ childMenu.name }}
                  </a-menu-item>
                  <a-sub-menu
                    class="secondLevel"
                    v-if="!childMenu.hidden && childMenu.child && childMenu.child.length > 0"
                    :key="childMenu.name"
                    @click="handleClick(childMenu)"
                  >
                    <span slot="title">
                      <span class="secondTitle">{{ childMenu.name }}</span>
                    </span>
                    <template v-for="childMenuThird in childMenu.child">
                      <a-menu-item :key="childMenuThird.name" @click="handleClick(childMenuThird)">
                        <span style="padding-left: 10px">{{ childMenuThird.name }} </span>
                      </a-menu-item>
                    </template>
                  </a-sub-menu>
                </template>
              </a-sub-menu>
            </template>
            <template v-else>
              <!-- 内容管理child为空，不展示 -->
              <a-menu-item
                v-if="menu.tag !== 'admin_portal_column'"
                :key="menu.name"
                @click="handleClick(menu)"
                class="firstLevel"
              >
                <!-- <img
                  class="icon-admin"
                  :src="menu.checked || nav.parentIndex === itemIndex || menu.hover ? menu.icon1 : menu.icon0"
                /> -->
                <a-icon type="credit-card" />
                <span>{{ menu.name }}</span>
              </a-menu-item>
            </template>
          </template>
        </a-menu>
      </div>
    </div>
    <div v-else :class="['teacher-menu', collapsed ? 'menu-collapsed' : '']">
      <div class="logo">
        <img src="@/assets/logo_1@2x.png" alt="" srcset="" />
      </div>
      <div class="menu">
        <a-menu
          :selectedKeys="defaultTeacherSelectedKeys"
          :open-keys="openKeys"
          mode="inline"
          theme="light"
          @openChange="onOpenChange"
          :inline-collapsed="collapsed"
        >
          <template v-for="menu in teacherMenu">
            <template v-if="menu.child && menu.child.length">
              <a-sub-menu v-if="!menu.hidden" :key="menu.name">
                <div slot="title" class="l-menu-title">
                  <img class="icon-admin" :src="menu.checked ? menu.icon1 : menu.icon0" />
                  <span v-if="!collapsed">{{ menu.name }}</span>
                </div>
                <template v-for="childMenu in menu.child">
                  <a-menu-item v-if="!childMenu.hidden" :key="childMenu.name" @click="handleClick(childMenu)">
                    {{ childMenu.name }}
                  </a-menu-item>
                </template>
              </a-sub-menu>
            </template>
            <template v-else>
              <!-- 内容管理child为空，不展示 -->
              <a-menu-item :key="menu.name" @click="handleClick(menu)" v-if="!menu.hidden" class="firstLevel">
                <img class="icon-admin anticon" :src="menu.checked || menu.hover ? menu.icon1 : menu.icon0" />
                <!-- <a-icon :type="menu.icon" /> -->
                <span>{{ menu.name }}</span>
              </a-menu-item>
            </template>
          </template>
        </a-menu>
      </div>
    </div>
  </div>
</template>

<script>
import TipModal from '@/components/tipModal/index.vue'
import jsCookie from 'js-cookie'
import { columnList, getPortalSubcolumnList } from '@/api/admin'
import { mapMutations, mapState } from 'vuex'
import { MENU_COLLAPSED } from '@/store/mutation-types'
import { EventBus } from '@/utils/eventBus'

export default {
  components: {
    TipModal
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      adminMenu: [
        {
          id: 1,
          checked: false,
          name: '教学管理',
          type: 'parent',
          hover: false,
          tag: 'admin_teacher',
          router: {
            name: 'semesterrList',
            path: '/teacher/semester/list'
          },
          icon: 'solution',
          icon0: require('@/assets/icons/icon_jx@2x.png'),
          icon1: require('@/assets/icons/icon_jx_x@2x.png'),
          child: [
            {
              id: '1-4',
              type: 'item',
              checked: true,
              name: '学期管理',
              tag: 'admin_semester_management',
              router: {
                name: 'semesterList',
                path: '/teacher/semester/list',
                query: {}
              }
            },
            {
              id: '1-2',
              type: 'item',
              checked: false,
              name: '校级资源',
              tag: 'admin_school_resource',
              router: {
                name: 'teacherResourceList',
                path: '/teacher/resourceList',
                query: {
                  model: 'admin'
                }
              }
            },
            {
              id: '1-4',
              type: 'item',
              checked: false,
              name: '课程管理',
              tag: 'admin_portal_lesson',
              router: {
                name: 'courseReviewer',
                path: '/teacher/courseReviewer',
                query: {
                  model: 'admin'
                }
              }
            },
            {
              id: '1-3',
              type: 'item',
              checked: false,
              name: '创建资源',
              hidden: true,
              childIndex: 1,
              router: {
                name: 'teacherResourceAdd',
                path: '/teacher/resourceAdd'
              }
            },
            {
              id: '1-3',
              type: 'item',
              checked: false,
              name: '资源详情',
              hidden: true,
              childIndex: 1,
              router: {
                name: 'teacherResourceDetails',
                path: '/teacher/resourceDetails'
              }
            },
            {
              id: '1-5',
              type: 'item',
              checked: false,
              name: '审核详情',
              hidden: true,
              childIndex: 2,
              router: {
                name: 'courseToReviewer',
                path: '/teacher/courseToReviewer'
              }
            },
            {
              id: '1-6',
              type: 'item',
              checked: false,
              name: '课程设置',
              hidden: true,
              childIndex: 2,
              router: {
                name: 'courseSet',
                path: '/teacher/courseSet'
              }
            }
          ]
        },
        {
          id: 30,
          checked: false,
          name: '组织管理',
          type: 'parent',
          hover: false,
          tag: 'admin_organization_management',
          router: {
            name: 'teacherList',
            path: '/teacher/list'
          },
          icon: 'solution',
          icon0: require('@/assets/icons/icon_zz.png'),
          icon1: require('@/assets/icons/icon_zz_s.png'),
          child: [
            {
              id: '30-1',
              type: 'item',
              checked: true,
              name: '老师管理',
              tag: 'admin_teacher_manage',
              router: {
                name: 'teacherList',
                path: '/teacher/list',
                query: {}
              }
            },
            {
              id: '30-2',
              type: 'item',
              checked: false,
              name: '创建老师',
              hidden: true,
              childIndex: 0,
              router: {
                name: 'teacherAdd',
                path: '/teacher/add'
              }
            },
            {
              id: '30-3',
              type: 'item',
              checked: false,
              name: '学生管理',
              tag: 'admin_student_management',
              childIndex: 1,
              router: {
                name: 'organizationStudentList',
                path: '/organization/student/list'
              }
            },
            {
              id: '30-4',
              type: 'item',
              checked: false,
              name: '班级管理',
              tag: 'admin_class_management',
              childIndex: 1,
              router: {
                name: 'organizationClassList',
                path: '/organization/class/list'
              }
            },
            {
              id: '30-5',
              type: 'item',
              checked: false,
              name: '外校师生',
              tag: 'admin_external_user_management',
              childIndex: 1,
              router: {
                name: 'organizationExternalList',
                path: '/organization/external/list'
              }
            },
          ]
        },
        {
          id: 19,
          checked: false,
          name: '教材中心',
          type: 'parent',
          hover: false,
          tag: 'admin_textbook',
          router: {
            name: 'textbookCenter',
            path: '/textbookCenter'
          },
          icon: 'barcode',
          icon0: require('@/assets/icons/icon_jc@2x.png'),
          icon1: require('@/assets/icons/icon_jc_x@2x.png'),
          child: [
            {
              id: '19-1',
              type: 'item',
              checked: false,
              name: '教材管理',
              tag: 'admin_textbook_manager',
              router: {
                name: 'textbookManage',
                path: '/textbookCenter/list',
                query: {}
              }
            },
            {
              id: '19-2',
              type: 'item',
              checked: false,
              name: '章节管理',
              tag: 'admin_textbook_manager',
              router: {
                name: 'chapterManage',
                path: '/textbookCenter/chapter',
                query: {}
              }
            },
            {
              id: '19-3',
              type: 'item',
              checked: false,
              name: '知识点管理',
              tag: 'admin_textbook_manager',
              router: {
                name: 'knowledgeManage',
                path: '/textbookCenter/knowledge',
                query: {}
              }
            },
            {
              id: '19-4',
              type: 'item',
              checked: false,
              name: '新建教材',
              hidden: true,
              childIndex: 0,
              router: {
                name: 'textbookManageEdit',
                path: '/t-examine/textbook/form'
              }
            },
            {
              id: '19-5',
              type: 'item',
              checked: false,
              name: '新建章节',
              hidden: true,
              childIndex: 1,
              router: {
                name: 'chapterManageEdit',
                path: '/t-examine/chapter/form'
              }
            },
            {
              id: '19-6',
              type: 'item',
              checked: false,
              name: '新建知识点',
              hidden: true,
              childIndex: 2,
              router: {
                name: 'knowledgeManageEdit',
                path: '/t-examine/knowledge/form'
              }
            }
          ]
        },
        {
          id: 15,
          checked: false,
          name: '实训场地',
          type: 'parent',
          hover: false,
          tag: 'admin_training_base',
          router: {
            name: 'trainingBase',
            path: '/trainingBase'
          },
          icon: 'solution',
          icon0: require('@/assets/icons/icon_sd@2x.png'),
          icon1: require('@/assets/icons/icon_sd_x@2x.png'),
          child: [
            {
              id: '15-1',
              type: 'item',
              checked: false,
              name: '实训室管理',
              tag: 'admin_training_room',
              router: {
                name: 'trainingRoom',
                path: '/trainingBase/list',
                query: {}
              }
            },
            {
              id: '15-2',
              type: 'item',
              checked: false,
              name: '设备管理',
              tag: 'admin_training_equipment',
              router: {
                name: 'equipmentList',
                path: '/trainingBase/equipmentList',
                query: {}
              }
            },
            {
              id: '15-3',
              type: 'item',
              checked: false,
              name: '预约管理',
              tag: 'admin_training_room_apply',
              router: {
                name: 'appointmentList',
                path: '/trainingBase/appointmentList',
                query: {}
              }
            },
            {
              id: '15-4',
              type: 'item',
              checked: false,
              hidden: true,
              childIndex: 0,
              name: '新建实训室',
              router: {
                name: 'trainingRoomAdd',
                path: '/trainingBase/trainingRoomAdd'
              }
            },
            {
              id: '15-4',
              type: 'item',
              checked: false,
              hidden: true,
              childIndex: 1,
              name: '新建实训设备',
              router: {
                name: 'equipmentListAdd',
                path: '/trainingBase/equipmentListAdd'
              }
            }
          ]
        },
        // 栏目管理
        {
          id: 3,
          checked: false,
          name: '栏目管理',
          type: 'parent',
          hover: false,
          tag: 'admin_portal_column',
          router: {
            name: 'columnList',
            path: '/column/list'
          },
          icon: 'barcode',
          icon0: require('@/assets/icons/icon_lm@2x.png'),
          icon1: require('@/assets/icons/icon_lm_x@2x.png'),
          child: [
            {
              id: 4,
              type: 'item',
              checked: false,
              name: '主栏目列表',
              tag: 'admin_portal_column',
              router: {
                name: 'columnList',
                path: '/column/list',
                query: {}
              }
            },
            {
              id: '3-1',
              type: 'item',
              checked: false,
              hidden: true,
              childIndex: 0,
              name: '新建栏目',
              router: {
                name: 'columnAdd',
                path: '/column/add'
              }
            },
            {
              id: '3-2',
              type: 'item',
              checked: false,
              name: '子栏目列表',
              tag: 'admin_portal_column',
              router: {
                name: 'subList',
                path: '/column/subList',
                query: {}
              }
            }
          ]
        },
        {
          id: 6,
          checked: false,
          name: '内容管理',
          type: 'parent',
          hover: false,
          tag: 'admin_portal_column',
          router: {
            name: '',
            path: ''
          },
          icon: 'profile',
          icon0: require('@/assets/icons/icon_nr@2x.png'),
          icon1: require('@/assets/icons/icon_nr_x@2x.png'),
          child: []
        },
        {
          id: 5,
          hover: false,
          name: '页眉页脚',
          type: 'parent',
          tag: 'admin_portal_column_header_footer',
          checked: false,
          hidden: false,
          icon: 'credit-card',
          icon0: require('@/assets/icons/icon_ym@2x.png'),
          icon1: require('@/assets/icons/icon_ym_x@2x.png'),
          router: {
            name: 'headerFooterConfig',
            path: '/header-footer/config'
          },
          child: []
        },
        {
          id: 12,
          checked: false,
          name: '实验设置',
          type: 'parent',
          hover: false,
          tag: 'admin_portal_column',
          router: {
            name: 'systemType',
            path: '/system/type'
          },
          icon: 'setting',
          icon0: require('@/assets/icons/icon_sys@2x.png'),
          icon1: require('@/assets/icons/menu_system_select.png'),
          child: [
            {
              id: 14,
              type: 'item',
              checked: false,
              name: '实验类型',
              tag: 'admin_portal_column',
              router: {
                name: 'systemType',
                path: '/system/type',
                query: {}
              }
            }
          ]
        },
        {
          id: 21,
          checked: false,
          name: '系统设置',
          type: 'parent',
          hover: false,
          tag: 'admin_system',
          router: {
            name: 'systemSchool',
            path: '/system/school'
          },
          icon: 'setting',
          icon0: require('@/assets/icons/icon_xt@2x.png'),
          icon1: require('@/assets/icons/icon_xt_x@2x.png'),
          child: [
            {
              id: '21-5',
              type: 'item',
              checked: false,
              name: '角色管理',
              tag: 'admin_permission_settings',
              router: {
                name: 'systemPermission',
                path: '/system/permission',
                query: {}
              }
            },
            {
              id: '21-1',
              type: 'item',
              checked: false,
              name: '学院字典',
              tag: 'admin_school_org',
              router: {
                name: 'systemSchool',
                path: '/system/school',
                query: {}
              }
            },
            {
              id: '21-2',
              type: 'item',
              checked: false,
              name: '敏感词管理',
              tag: 'admin_sensitive_words',
              router: {
                name: 'sensitive',
                path: '/system/sensitive',
                query: {}
              }
            },
            {
              id: '21-3',
              type: 'item',
              checked: false,
              name: '评论管理',
              tag: 'admin_comment',
              router: {
                name: 'comment',
                path: '/system/comment',
                query: {}
              }
            },
            {
              id: '21-4',
              type: 'item',
              checked: false,
              name: '收藏点赞管理',
              tag: 'admin_resource_interactions',
              router: {
                name: 'favorites',
                path: '/system/favorites',
                query: {}
              }
            },
            {
              id: '21-5',
              type: 'item',
              checked: false,
              name: '接口规范',
              tag: 'admin_openapi_doc',
              router: {
                name: 'document',
                path: '/system/document',
                query: {}
              }
            },
            {
              id: '21-6',
              type: 'item',
              checked: false,
              name: '接口调试',
              tag: 'admin_openapi_debug',
              router: {
                name: 'debugging',
                path: '/system/debugging',
                query: {}
              }
            }
          ]
        },
        {
          id: 18,
          checked: false,
          name: '系统统计',
          type: 'parent',
          hover: false,
          tag: 'admin_system_monitor',
          router: {
            name: 'operationlog',
            path: '/systemStatistics/list'
          },
          icon: 'setting',
          icon0: require('@/assets/icons/icon_tj@2x.png'),
          icon1: require('@/assets/icons/icon_tj_x@2x.png'),
          child: [
            {
              id: '18-1',
              type: 'item',
              checked: false,
              name: '操作日志',
              tag: 'admin_operation_log',
              router: {
                name: 'operationlog',
                path: '/systemStatistics/list',
                query: {}
              }
            }
          ]
        },
        {
          id: 20,
          hover: false,
          name: 'BI分析',
          type: 'parent',
          checked: false,
          hidden: false,
          icon: 'credit-card',
          tag: 'admin_bi_center',
          icon0: require('@/assets/icons/icon_fx@2x.png'),
          icon1: require('@/assets/icons/icon_fx_x@2x.png'),
          router: {
            name: 'dataAnalysis',
            path: '/dataAnalysis/screen'
          },
          child: [
            {
              id: '20-1',
              type: 'item',
              checked: false,
              name: '数据大屏',
              tag: 'admin_bi',
              router: {
                name: 'biAnalysis',
                path: '/dataAnalysis/biAnalysis',
                query: {}
              }
            },
            {
              id: '20-2',
              type: 'item',
              checked: false,
              name: '老师画像',
              tag: 'admin_teacher_portrayal',
              router: {
                name: 'dataAnalysisTeacher',
                path: '/dataAnalysis/teacher',
                query: {}
              }
            },
            {
              id: '20-3',
              type: 'item',
              checked: false,
              name: '图表类型',
              tag: 'admin_bi',
              router: {
                name: 'dataAnalysisDetail',
                path: '/dataAnalysis/detail'
              }
            }
          ]
        }
      ],
      teacherMenu: [
        {
          id: 1,
          hover: false,
          name: '首页',
          type: 'parent',
          checked: true,
          hidden: false,
          tag: 'school_index',
          icon: 'home',
          icon0: require('@/assets/icons/icon_sy_x.png'),
          icon1: require('@/assets/icons/icon_sy.png'),
          router: {
            name: 'index',
            path: '/index'
          }
        },
        {
          id: 2,
          hover: false,
          name: '教学',
          type: 'parent',
          checked: false,
          hidden: true,
          tag: 'school_lesson_center',
          stu_tag: 'student_teaching',
          icon0: require('@/assets/icons/icon_kc@2x.png'),
          icon1: require('@/assets/icons/icon_kc_x@2x.png'),
          router: {
            name: 'prepareList',
            path: '/course/prepare/list'
          },
          child: [
            {
              id: '2-1',
              name: '我的课程',
              type: 'item',
              hover: false,
              tag: 'school_prepare_lesson',
              checked: false,
              hidden: false,
              router: {
                name: 'myCourses',
                path: '/courses/myCourses'
              }
            },
            {
              id: '2-1',
              name: '新建课程',
              type: 'item',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 0,
              router: {
                name: 'addCourses',
                path: '/courses/addCourses'
              }
            },
            {
              id: '2-3',
              name: '选课',
              type: 'item',
              stu_tag: 'student_entry',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 0,
              router: {
                name: 'selectCourses',
                path: '/courses/select'
              }
            },
            {
              id: '2-7',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '实训室预约',
              tag: 'teacher_training_room_apply',
              childIndex: 2,
              router: {
                name: 'trainingAppointment',
                path: '/training/trainingAppointment'
              }
            },
            {
              id: '2-8',
              name: '共享至门户',
              type: 'item',
              tag: 'teacher_share2portal',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 0,
              router: {
                name: 'shareToPortal',
                path: '/courses/shareToPortal'
              }
            },
            {
              id: '2-9',
              name: '发布导学',
              type: 'item',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 0,
              router: {
                name: 'tutorialRelease',
                path: '/courses/tutorialRelease'
              }
            },
            {
              id: '2-10',
              name: '导学报告',
              type: 'item',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 0,
              router: {
                name: 'lessonList',
                path: '/course/lesson/list'
              }
            },
            {
              id: '2-11',
              name: '导学报告',
              type: 'item',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 0,
              router: {
                name: 'guidanceReports',
                path: '/course/lesson/guidanceReports'
              }
            },
            {
              id: '2-12',
              name: '课程生成',
              type: 'item',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 0,
              router: {
                name: 'generationCourse',
                path: '/course/lesson/generationCourse'
              }
            }
          ]
        },
        {
          id: 11,
          hover: false,
          type: 'parent',
          checked: false,
          hidden: true,
          name: '考核',
          tag: 'teacher_examination',
          stu_tag: 'student_examination',
          icon0: require('@/assets/icons/icon_ll@2x.png'),
          icon1: require('@/assets/icons/icon_ll_x@2x.png'),
          router: {
            name: 'theoryQuestionBank',
            path: '/theory/theoryQuestionBank'
          },
          child: [
            {
              id: '11-1',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '题库管理',
              tag: 'teacher_theoretical_examination_manager',
              childIndex: 0,
              router: {
                name: 'theoryQuestionBank',
                path: '/theory/theoryQuestionBank'
              }
            },
            {
              id: '11-2',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '试卷管理',
              tag: 'teacher_theoretical_examination_manager',
              childIndex: 1,
              router: {
                name: 'theoryExaminationPaper',
                path: '/theory/theoryExaminationPaper'
              }
            },
            {
              id: '11-3',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '理论考核',
              tag: 'teacher_theoretical_examination_manager',
              childIndex: 2,
              router: {
                name: 'theoryCheck',
                path: '/theory/theoryCheck'
              }
            },
            {
              id: '11-13',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '实验考核',
              tag: 'teacher_experiment_evaluation',
              stu_tag: 'student_experiment_evaluation',
              router: {
                name: 'experimentCheck',
                path: '/experiment/experimentCheck'
              }
            },
            {
              id: '11-16',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '实验练习数据',
              tag: 'teacher_experiment_exercise_data',
              stu_tag: 'student_experiment_exercise_data',
              childIndex: 2,
              router: {
                name: 'experimenExercise',
                path: '/experimen/experimnExercise'
              }
            },
            {
              id: '11-4',
              type: 'item',
              checked: false,
              hidden: true,
              name: '查看学情',
              childIndex: 2,
              router: {
                name: 'theoryCheckView',
                path: '/theory/theoryCheckView'
              }
            },
            {
              id: '11-5',
              type: 'item',
              checked: false,
              hidden: true,
              name: '考核',
              childIndex: 2,
              router: {
                name: 'theoryCheckExamine',
                path: '/theory/theoryCheckExamine'
              }
            },
            {
              id: '11-6',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '理论考核',
              stu_tag: 'student_theoretical_examination',
              childIndex: 2,
              router: {
                name: 'theoryCheckStudent',
                path: '/t-examine/stuexamine'
              }
            },
            {
              id: '11-7',
              type: 'item',
              checked: false,
              hidden: true,
              childIndex: 0,
              name: '编辑试题',
              router: {
                name: 'theoryQuestionBankEdit',
                path: '/t-examine/question/form'
              }
            },
            {
              id: '11-8',
              type: 'item',
              checked: false,
              hidden: true,
              childIndex: 1,
              name: '编辑试题',
              router: {
                name: 'theoryExaminationPaperEdit',
                path: '/t-examine/testPaper/form'
              }
            },
            {
              id: '11-9',
              type: 'item',
              checked: false,
              hidden: true,
              childIndex: 2,
              name: '编辑试题',
              router: {
                name: 'theoryCheckEdit',
                path: '/t-examine/examine/form'
              }
            },
            {
              id: '11-10',
              type: 'item',
              checked: false,
              hidden: true,
              childIndex: 2,
              name: '查看学情',
              router: {
                name: 'theoryCheckView',
                path: '/t-examine/study'
              }
            },
            {
              id: '11-11',
              type: 'item',
              checked: false,
              hidden: true,
              childIndex: 2,
              name: '去考核',
              router: {
                name: 'studentExamination',
                path: '/t-examine/examination'
              }
            },
            {
              id: '11-12',
              type: 'item',
              checked: false,
              hidden: true,
              childIndex: 2,
              name: '查看学情',
              router: {
                name: 'studentView',
                path: '/t-examine/viewtestpaper'
              }
            },
            {
              id: '11-14',
              type: 'item',
              checked: false,
              hidden: true,
              hover: false,
              name: '查看学情',
              childIndex: 3,
              router: {
                name: 'experimentCheckView',
                path: '/experimen/experimentCheckView'
              }
            },
            {
              id: '11-15',
              type: 'item',
              checked: false,
              hidden: true,
              hover: false,
              name: '考核',
              childIndex: 3,
              router: {
                name: 'experimenCheckExamine',
                path: '/experimen/experimenCheckExamine'
              }
            },
            {
              id: '11-17',
              type: 'item',
              checked: false,
              hidden: true,
              hover: false,
              name: '新增编辑',
              childIndex: 3,
              router: {
                name: 'experimentAddEditCheck',
                path: '/experimen/experimentAddEditCheck'
              }
            }
          ]
        },
        {
          id: 8,
          hover: false,
          type: 'parent',
          checked: false,
          hidden: false,
          name: '资源',
          tag: 'school_resource',
          stu_tag: 'student_resource',
          icon0: require('@/assets/icons/icon_zy@2x.png'),
          icon1: require('@/assets/icons/icon_zy_x@2x.png'),
          router: {
            name: 'resourceList',
            path: '/resource/resourceList'
          },
          child: [
            {
              id: 9,
              type: 'item',
              hover: false,
              checked: false,
              hidden: false,
              name: '校本资源',
              tag: 'school_common_resource',
              stu_tag: 'student_common_resource',
              router: {
                name: 'resourceList',
                path: '/resource/resourceList'
              }
            },
            {
              id: '8-1',
              type: 'item',
              hover: false,
              checked: false,
              hidden: false,
              name: '个人资源',
              tag: 'teacher_self_resource',
              stu_tag: 'student_self_resource',
              router: {
                name: 'resourcePrivate',
                path: '/resource/resourcePrivate'
              }
            },
            {
              id: 10,
              type: 'item',
              checked: false,
              hidden: true,
              name: '资源详情',
              childIndex: 0,
              router: {
                name: 'resourceDetail',
                path: '/resource/detail'
              }
            },
            {
              id: '8-2',
              type: 'item',
              checked: false,
              hidden: true,
              name: '资源添加',
              childIndex: 1,
              router: {
                name: 'resourcePrivateAdd',
                path: '/resource/resourcePrivateAdd'
              }
            },
            {
              id: '8-3',
              type: 'item',
              checked: false,
              hidden: true,
              name: '资源详情',
              childIndex: 1,
              router: {
                name: 'resourcePrivateDetails',
                path: '/resource/resourcePrivateDetails'
              }
            }
          ]
        },
        {
          id: 5,
          hover: false,
          type: 'parent',
          checked: false,
          name: '研创',
          hidden: true,
          tag: 'school_lesson_create',
          icon0: require('@/assets/icons/icon_yc_m@2x.png'),
          icon1: require('@/assets/icons/icon_yc@2x.png'),
          router: {
            name: 'createLessonList',
            path: 'create/lesson/list'
          }
        },
        {
          id: 12,
          hover: false,
          type: 'parent',
          checked: false,
          hidden: true,
          name: 'AI工作台',
          tag: 'teacher_ai_workbench',
          stu_tag: 'student_ai_workbench',
          icon0: require('@/assets/icons/icon_yc.png'),
          icon1: require('@/assets/icons/icon_yc_m.png'),
          router: {
            name: 'repository',
            path: 'AI/repository'
          },
          child: [
            {
              id: '12-1',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '智能问答',
              tag: 'teacher_ai_chat',
              stu_tag: 'student_ai_chat',
              childIndex: 0,
              router: {
                name: 'aiChat',
                path: '/ai/chat'
              }
            },
            {
              id: '12-2',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '全部应用',
              tag: 'teacher_ai_all_app',
              stu_tag: 'student_ai_all_app',
              childIndex: 0,
              router: {
                name: 'aiApp',
                path: '/AI/app'
              }
            },
            {
              id: '12-3',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '知识库',
              tag: 'teacher_ai_datasets',
              stu_tag: 'student_ai_datasets',
              childIndex: 0,
              router: {
                name: 'repository',
                path: '/AI/repository'
              }
            },
            {
              id: '12-4',
              type: 'item',
              checked: false,
              hidden: false,
              hover: false,
              name: '模型广场',
              tag: 'teacher_ai_models',
              stu_tag: 'student_ai_models',
              childIndex: 0,
              router: {
                name: 'aiModel',
                path: '/AI/model'
              }
            },
            {
              id: '12-5',
              name: '文件列表',
              type: 'item',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 2,
              router: {
                name: 'repositoryFileDetails',
                path: '/AI/repositoryFileDetails'
              }
            },
            {
              id: '12-6',
              name: '分段详情',
              type: 'item',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 2,
              router: {
                name: 'repositoryDetails',
                path: '/AI/repositoryDetails'
              }
            },
            {
              id: '12-7',
              name: '文件设置',
              type: 'item',
              hover: false,
              checked: false,
              hidden: true,
              childIndex: 2,
              router: {
                name: 'createFlow',
                path: '/AI/createFlow'
              }
            },
          ]
        }
      ],
      openKeys: [],
      rootSubmenuKeys: [],
      defaultSelectedKeys: [],
      teacherSelectedKeys: [],
      defaultTeacherSelectedKeys: []
    }
  },
  computed: {
    ...mapState({
      collapsed: state => state.app.collapsed
    }),
    nav() {
      const obj = {
        parentIndex: 0,
        childIndex: -1
      }
      const routeName = this.$route.name
      this.teacherMenu.forEach((item, parentIndex) => {
        item.checked = item.router.name === routeName
        if (item.router.name === routeName) obj.parentIndex = parentIndex
        if (!item.child || item.child.length === 0) return
        item.child.forEach((child, childIndex) => {
          child.checked = child.router.name === routeName
          if (child.router.name === routeName) {
            obj.parentIndex = parentIndex
            obj.childIndex = child.childIndex > -1 ? child.childIndex : childIndex
            item.checked = true
          }
        })
      })
      return obj
    }
  },
  watch: {
    $route(to, from) {
      if (['columnList', 'subList', 'permission'].includes(to.name)) {
        this.getColumnList()
      }
      if (to.name === 'permission') {
        this.goFirstMenu()
      }
      if (to.name === 'personal') return
      this.isCheck()
    }
  },
  methods: {
    ...mapMutations([MENU_COLLAPSED]),
    handleClick(obj) {
      if (!this.isAdmin) {
        this.teacherMenu.forEach(item => {
          if (item.id === obj.id) {
            item.checked = !item.checked
            if (!item.checked) return
            if (!item.child) {
              this.$router.push({
                name: obj.router.name,
                query: obj.router.query
              })
            } else if (item.child.length > 0) {
              item.child[0].checked = !item.child[0].checked
              this.$router.push({
                name: obj.router.name,
                query: obj.router.query
              })
            }
          } else {
            item.checked = false
            if (!item.child || item.child.length === 0) return
            item.child.forEach(it => {
              if (it.id === obj.id) {
                item.checked = true
                if (it.checked) return
                it.checked = true
                this.$router.push({
                  name: obj.router.name,
                  query: obj.router.query
                })
              } else {
                it.checked = false
              }
            })
          }
        })
        console.log('this.teacherMenu ----->', this.teacherMenu)
      } else {
        this.adminMenu.forEach(item => {
          if (item.id === obj.id) {
            if (item.checked) return
            this.$router.push({
              name: obj.router.name,
              query: obj.router.query
            })
          } else {
            if (!item.child || item.child.length === 0) return
            item.child.forEach(it => {
              if (it.id === obj.id && (!it.child || it.child.length === 0)) {
                if (it.checked) return
                this.$router.push({
                  name: obj.router.name,
                  query: obj.router.query
                })
              } else {
                if (!it.child || it.child.length === 0) return
                it.child.forEach(itThird => {
                  if (itThird.id === obj.id) {
                    if (itThird.checked) return
                    this.$router.push({
                      name: obj.router.name,
                      query: obj.router.query
                    })
                  }
                })
              }
            })
          }
        })
        this.$forceUpdate()
      }
      // this.defaultTeacherSelectedKeys = [obj.name]
      // this.defaultSelectedKeys = [obj.name]
    },
    async getColumnList() {
      const res = await columnList()
      const resSub = await getPortalSubcolumnList({
        pageSize: 10000
      })
      const permissionList = localStorage.permissionList || ''
      const permissionListArr = permissionList.split(',')
      const findContent = this.adminMenu.find(item => item.id === 6)

      if (res.code === 200) {
        this.columnList = res.data.list
        let portalStatus = false
        this.columnList.forEach(item => {
          if (item.status === 1 && permissionListArr.includes(findContent.tag)) {
            portalStatus = true
          }
          if (item.type === 2) {
            localStorage.setItem('experiment_column_id', item.id)
          }
        })
        findContent.hidden = !portalStatus
        if (!portalStatus) return
        const mainContent = {
          id: '6-1',
          type: 'item',
          checked: false,
          name: '主栏目内容',
          tag: 'admin_portal_column',
          router: {
            name: '',
            path: ''
          },
          child: []
        }
        findContent.child = [mainContent]
        this.injectRouter(mainContent, this.columnList)
      }
      if (resSub.code === 200) {
        this.subColumnList = resSub.data.list
        const findContent = this.adminMenu.find(item => item.id === 6)
        const subContent = {
          id: '6-2',
          type: 'item',
          checked: false,
          name: '子栏目内容',
          tag: 'admin_portal_column',
          router: {
            name: '',
            path: ''
          },
          child: []
        }
        findContent.child.push(subContent)
        this.injectRouter(subContent, this.subColumnList)
      }
      this.isCheck()
    },
    // 内容路由注入
    injectRouter(content, data) {
      const mapRouter = {
        1: 'newsList',
        3: 'videoList',
        4: 'introduceAdd',
        2: 'labList',
        92: 'recruitList'
      }
      const mapEditRouter = {
        1: 'newsAdd',
        3: 'videoAdd',
        90: 'bannerAdd',
        2: 'labAdd'
      }
      data.forEach(item => {
        if (item.type === 90 && item.status === 1) {
          content.child.push({
            id: 200,
            type: 'item',
            checked: false,
            name: 'Banner管理',
            tag: 'admin_200',
            router: {
              name: 'bannerList',
              editName: mapEditRouter[item.type],
              query: {}
            }
          })
        }
        if ((item.type >= 5 && item.type != 92) || item.status === 2) return
        if (content) {
          content.child.push({
            id: 100 + item.id,
            type: 'item',
            checked: false,
            name: item.title,
            tag: 'admin_' + item.id,
            router: {
              name: mapRouter[item.type],
              editName: mapEditRouter[item.type],
              query: {
                columnId: item.id,
                pColumnTitle: item.parentName,
                columnTitle: item.title
              }
            }
          })
        }
      })
    },
    // 判断是否选中
    isCheck() {
      const routeName = this.$route.name
      const columnId = this.$route.query.columnId
      this.adminMenu.forEach(item => {
        if (item.child.length === 0) {
          item.checked = false
          if (item.router.name === routeName) {
            item.checked = true
            this.defaultSelectedKeys = [item.name]
          }
        } else {
          item.checked = false
          if (!item.child || item.child.length === 0) return
          item.child.forEach(it => {
            if (it.router.name === routeName || it.router.editName === routeName) {
              item.checked = true
              it.checked = true
              if (!this.collapsed) {
                this.openKeys = [item.name]
              } else {
                this.openKeys = []
              }
              if (it.hidden) {
                if (item.child[it.childIndex]) this.defaultSelectedKeys = [item.name, item.child[it.childIndex].name]
              } else {
                this.defaultSelectedKeys = [item.name, it.name]
              }
            } else {
              it.checked = false
              if (!it.child || it.child.length === 0) return
              it.child.forEach(itThird => {
                if (
                  (itThird.router.name === routeName || itThird.router.editName === routeName) &&
                  itThird.router.query.columnId == columnId
                ) {
                  // if (itThird.checked) return
                  if (!this.collapsed) {
                    this.openKeys = [item.name, it.name, itThird.name]
                  } else {
                    this.openKeys = []
                  }
                  this.defaultSelectedKeys = [item.name, it.name, itThird.name]
                  it.checked = true
                  itThird.checked = true
                } else {
                  itThird.checked = false
                }
              })
            }
          })
        }
        this.rootSubmenuKeys.push(item.name)
      })
      this.teacherMenu.forEach(item => {
        if (!item.child || item.child.length === 0) {
          item.checked = false
          if (item.router.name === routeName) {
            item.checked = true
            this.defaultTeacherSelectedKeys = [item.name]
          }
        } else {
          item.checked = false
          if (!item.child || item.child.length === 0) return
          item.child.forEach(it => {
            if (it.router.name === routeName) {
              item.checked = true
              it.checked = true
              if (!this.collapsed && this.$route.name !== 'addCourses') {
                this.openKeys = [item.name]
              } else {
                this.openKeys = []
              }
              if (it.hidden) {
                this.defaultTeacherSelectedKeys = [item.name, item.child[it.childIndex].name]
              } else {
                this.defaultTeacherSelectedKeys = [item.name, it.name]
              }
            } else {
              it.checked = false
            }
          })
        }
        this.rootSubmenuKeys.push(item.name)
      })
      this.$forceUpdate()
    },
    // 老师和管理员的路由权限
    isRouterPermission(tag) {
      if (localStorage.roles) {
        const roles = JSON.parse(localStorage.roles)
        if (!roles.includes('admin')) {
          return true
        } else {
          return roles.includes(tag)
        }
      }
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
    toggleCollapsed(flag) {
      if (flag) {
        this.openKeys = []
      }
      this[MENU_COLLAPSED](flag)
    },
    handleResize(event) {
      if (event.target.innerWidth <= 1300) {
        this.toggleCollapsed(true)
      } else {
        this.toggleCollapsed(false)
      }
    },
    handleWindowSize() {
      if (window.innerWidth <= 1300) {
        this.toggleCollapsed(true)
      } else {
        this.toggleCollapsed(false)
      }
    },
    // 前往默认的第一个菜单
    goFirstMenu() {
      const isAdmin = this.$route.query.isAdmin === '1'
      const menu = isAdmin ? 'adminMenu' : 'teacherMenu'
      const firstMenu = this[menu].find(item => !item.hidden)
      console.log('firstMenu ----->', firstMenu)
      if (firstMenu) {
        if (firstMenu.child && firstMenu.child.length > 0) {
          const firstMenuSub = firstMenu.child.find(item => !item.hidden)
          if (firstMenuSub) this.$router.push(firstMenuSub.router)
        } else {
          this.$router.push(firstMenu.router)
        }
      } else {
        this.$emit('changePermission', true)
      }
    }
  },
  mounted() {
    const userInfo = JSON.parse(jsCookie.get('user_infor'))
    const userType = JSON.parse(jsCookie.get('user_type')).join(',')
    const tagKey = userType.includes('student') ? 'stu_tag' : 'tag'
    const permissionList = localStorage.permissionList || ''
    const btnPermissionList = ['teacher_share2portal']
    let permissionListArr = permissionList.split(',')
    // 校外师生权限
    console.log('userType ----->', userType)
    if (userType.includes('external')) {
      if (userType.includes('student')) {
        permissionListArr = [...permissionListArr, 'student_resource', 'student_common_resource']
      } else {
        permissionListArr = [...permissionListArr, 'school_resource', 'school_common_resource']
      }
      this.teacherMenu.shift()
    }
    /***
     * 学生账号权限处理
     */
    if (userType.includes('student')) {
      permissionListArr = permissionListArr.filter(item => item.includes('student_'))
      this.teacherMenu = this.teacherMenu.filter(menu => {
        return [8, 11, 12, 2].includes(menu.id)
      })
    }
    /***
     * 教学平台权限处理
     */
    this.teacherMenu.forEach((item, index) => {
      if (userType.includes('student') || index > 0) {
        item.hidden = !permissionListArr.includes(item[tagKey])
        if (!item.child || item.child.length === 0) return
        item.child.forEach(child => {
        // 如果权限项在 btnPermissionList 中，则不更改 hidden 状态
          child.hidden = btnPermissionList.includes(child[tagKey]) ? child.hidden : !permissionListArr.includes(child[tagKey])
        })
      }
    })
    /***
     * 管理后台权限处理
     */
    if (!permissionList.includes('admin_portal_column')) {
      // 删除adminMenu数组下标1-5的
      this.adminMenu = this.adminMenu.filter(item => item.tag !== 'admin_portal_column_header_footer')
    }
    this.adminMenu.forEach((item, index) => {
      item.hidden = !permissionListArr.includes(item.tag)
      if (!item.child || item.child.length === 0) return
      item.child.forEach(child => {
        child.hidden = !permissionListArr.includes(child.tag)
      })
    })

    const menu = this.isAdmin ? this.adminMenu : this.teacherMenu
    if (menu && !menu.find(item => !item.hidden)) {
      this.$emit('changePermission', true)
    }
    if (['admin@wxx', 'admin@bit', 'admin@bjlg', 'admin@ltg', 'admin@shuide'].includes(userInfo.username)) {
      // 临时将demo数据展示放入
      // this.teacherMenu.push({
      //   id: 200,
      //   hover: false,
      //   name: '考核中心',
      //   type: 'parent',
      //   checked: false,
      //   hidden: false,
      //   icon0: require('@/assets/icons/icon_sy.png'),
      //   icon1: require('@/assets/icons/icon_sy_x.png'),
      //   router: {
      //     name: 'assess',
      //     path: '/data/assess'
      //   }
      // })
    }
    this.handleWindowSize()
    this.isCheck()
    this.getColumnList()
    this.$emit(
      'changeMenuData',
      this.teacherMenu.filter(menu => {
        return !menu.hidden
      })
    )
    window.addEventListener('resize', this.handleResize)
    if (this.$route.name === 'permission') {
      this.goFirstMenu()
    }
    // 监听子栏目删除事件
    EventBus.$on('RemoveSubColumn', () => {
      this.getColumnList()
    })
    EventBus.$on('ClearOpenKeys', () => {
      this.openKeys = []
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    EventBus.$off('RemoveSubColumn')
    EventBus.$off('ClearOpenKeys')
  }
}
</script>

<style lang="less" scoped>
.collapsed {
  position: absolute;
  right: -60px;
  top: 13px;
  min-width: 50px !important;
  cursor: pointer;
  img {
    width: 30px;
  }
}
.admin-menu,
.teacher-menu {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  justify-content: center;
  background: url('./../../assets/img/bj_zc.png');
  background-size: 112% 100%;
  background-position: center;
  transition: width 0.3s ease-out;
  .l-menu-title {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .logo {
    margin: 28px 0 53px;
    display: flex;
    justify-content: center;
    img {
      width: 64px;
    }
  }
  .menu {
    width: 100%;
    padding-left: 20px;
    .list {
      width: 100%;
      margin-bottom: 9px;
      .title {
        width: 100%;
        color: #000;
        // height: 54px;
        display: flex;
        cursor: pointer;
        font-size: 19px;
        position: relative;
        align-items: center;
        padding: 15px 32px 15px 26px;
      }
      .icon-logo {
        width: 18px;
        margin-right: 12px;
      }
      .icon-control {
        width: 10px;
        right: 20px;
        position: absolute;
      }
      .child {
        width: 100%;
        .item {
          cursor: pointer;
          font-size: 16px;
          padding: 9px 16px 9px 52px;
          &:first-child {
            margin-top: 9px;
          }
        }
      }
    }
    /deep/ .ant-menu-dark {
      padding-left: 10px !important;
    }
    /deep/ .ant-menu {
      background-color: #3d3e41;
      color: #fff;
      .ant-menu-submenu:hover,
      .ant-menu-item:hover {
        > .ant-menu-submenu-title {
          color: #ffa000;
          .ant-menu-submenu-arrow::after {
            color: #ffa000 !important;
          }
        }
        .icon-admin-cover {
          overflow: hidden;
          position: relative;
        }
        .icon-admin {
          transform: translateY(-60px);
          filter: drop-shadow(#ffa000 0 60px);
        }
      }
      .ant-menu-submenu-selected {
        .icon-admin-cover {
          overflow: hidden;
          position: relative;
        }
        .icon-admin {
          transform: translateY(-60px);
          filter: drop-shadow(#ffa000 0 60px);
        }
      }
      .ant-menu-submenu {
        .ant-menu-item {
          border-radius: 6px 0px 0px 6px;
        }
        .ant-menu-item:hover {
          color: #ff6600;
          background: #ffffff !important;
        }
      }
      .ant-menu-inline .ant-menu-item::after {
        border: none;
      }
      .ant-menu-item-selected {
        color: #ff6600 !important;
        background-color: #3d3e41;
        .anticon,
        span {
          color: #ffa000;
        }
      }
      .ant-menu-submenu-title {
        font-size: 16px;
        padding-left: 0px !important;
      }
    }
    .icon-admin {
      width: 29px;
      padding-right: 13px;
      margin-right: 0px;
      width: 14px;
      height: 16px;
      box-sizing: content-box;
    }
  }
}
.teacher-menu {
  .menu {
    // width: calc(100% - 25px);
    /deep/ .ant-menu {
      color: #000;
      background: transparent;
      border: none;
      .firstLevel {
        span {
          color: #000;
        }
      }
      .ant-menu-item {
        color: #545454;
        padding-left: 55px !important;
        &:hover {
          > .icon-admin {
            transform: translateY(-60px);
            filter: drop-shadow(#fff 0 60px);
          }
        }
      }
      .ant-menu-submenu-title {
        padding-left: 26px !important;
        .ant-menu-submenu-arrow::before,
        .ant-menu-submenu-arrow::after {
          background-image: linear-gradient(to right, #a9a9a9, #a9a9a9);
        }
      }
      .ant-menu-submenu {
        .ant-menu-item-selected {
          background: transparent !important;
        }
        .ant-menu-item:hover {
          background: transparent !important;
        }
      }
      .ant-menu-submenu:hover {
        .ant-menu-submenu-title {
          color: #fff !important;
          background: linear-gradient(248deg, #f5a623, #ff6d00);
          box-shadow: 0 0 3px 0 rgba(204, 76, 26, 0.12);
          border-radius: 6px 0 0 6px;
          .ant-menu-submenu-arrow::before,
          .ant-menu-submenu-arrow::after {
            background: #fff;
          }
          .icon-admin {
            filter: drop-shadow(#fff 0 60px);
          }
        }
      }
      .ant-menu-submenu-selected {
        .icon-admin {
          filter: drop-shadow(#fff 0 60px);
        }
      }
      .firstLevel {
        padding-left: 26px !important;
        &:hover {
          color: #fff !important;
          background: linear-gradient(248deg, #f5a623, #ff6d00);
          border-radius: 6px 0 0 6px;
          span {
            color: #fff !important;
          }
          .anticon {
            font-size: 16px;
            color: #fff;
          }
        }
        .anticon {
          font-size: 16px;
          color: #000;
        }
      }
      .ant-menu-submenu-selected {
        > .ant-menu-submenu-title {
          color: #fff !important;
          background: linear-gradient(248deg, #f5a623, #ff6d00);
          border-radius: 6px 0 0 6px;
          span {
            color: #fff;
          }
          .ant-menu-submenu-arrow::before,
          .ant-menu-submenu-arrow::after {
            background: #fff;
          }
        }
      }
      .firstLevel.ant-menu-item-selected {
        color: #fff !important;
        background: linear-gradient(248deg, #f5a623, #ff6d00);
        border-radius: 6px 0 0 6px;
        span {
          color: #fff;
        }
      }
      .ant-menu-item-selected .anticon {
        color: #fff !important;
      }
      .ant-menu-item-selected {
        .icon-admin {
          transform: translateY(-60px);
          filter: drop-shadow(#fff 0 60px);
        }
      }
    }
  }
  .list {
    .title.selected {
      color: #fff;
      background: linear-gradient(248deg, #f5a623 0%, #ff6d00 100%);
      box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
      border-radius: 6px 0px 0px 6px;
    }
    .item.selected {
      color: #ff6d00;
    }
  }
}
.admin-menu {
  background: #3d3e41;
  .menu {
    .list {
      padding-left: 10px;
      .title {
        color: #fff;
        padding-left: 0 !important;
        font-size: 16px;
        padding: 10px;
        overflow: hidden;
        &:hover {
          color: #ffa000 !important;
          img {
            transform: translateY(-60px);
            filter: drop-shadow(#ffa000 0 60px);
          }
        }
      }
      .child {
        .item {
          padding-left: 40px;
          .item-name {
            color: #fff;
            font-size: 14px;
          }
        }
      }
      .title.selected {
        color: #ffa000;
        background: none;
      }
      .item:hover {
        background: #ffffff;
        border-radius: 6px 0px 0px 6px;
        .item-name {
          color: #ff6600;
        }
      }
      .item.selected {
        background: #ffffff;
        border-radius: 6px 0px 0px 6px;
        .item-name {
          color: #ff6600;
        }
      }
    }
    .firstLevel {
      .anticon {
        font-size: 16px;
      }
    }
    .firstLevel:hover {
      .anticon {
        color: #ffa000;
      }
    }
    .ant-menu .ant-menu-submenu .ant-menu-item {
      padding-left: 30px !important;
    }
  }
}

.menu-collapsed {
  .menu {
    padding-left: 0 !important;
    .ant-menu {
      padding-left: 0 !important;
      .ant-menu-submenu {
        /deep/ .ant-menu-submenu-title {
          padding-left: 32px !important;
        }
      }
      .firstLevel {
        padding-left: 31px !important;
      }
    }
    .list {
      .title {
        height: 40px;
        line-height: 40px;
        overflow: hidden;
      }
    }
    .menu-title {
      max-width: 0;
      opacity: 0;
    }
    .icon-control {
      opacity: 0;
    }
  }
  .logo {
    margin: 28px 0 28px;
    display: flex;
    justify-content: center;
    img {
      width: 60px !important;
    }
  }
}

.teacher-menu.menu-collapsed {
  width: 98px !important;
  .menu {
    /deep/ .ant-menu {
      margin-left: 9px;
      .ant-menu-submenu {
        .ant-menu-submenu-title {
          background-size: 70px 46px;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .ant-menu-submenu:hover,
      .ant-menu-submenu-selected {
        > .ant-menu-submenu-title {
          transition: none;
          background-image: url(~@/assets/img/bj_dh@2x.png);
        }
      }
      .firstLevel {
        background-size: 70px 46px;
        background-position: center;
        background-repeat: no-repeat;
      }
      .firstLevel:hover,
      .firstLevel.ant-menu-item-selected {
        background-image: url(~@/assets/img/bj_dh@2x.png);
      }
    }
  }
}
.admin-menu.menu-collapsed {
  width: 80px !important;
  .menu {
    /deep/ .ant-menu {
      .ant-menu-submenu {
        img {
          padding-bottom: 2px;
        }
        .ant-menu-submenu-title {
          background-size: 40px 40px;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .ant-menu-submenu:hover,
      .ant-menu-submenu-selected {
        > .ant-menu-submenu-title {
          transition: none;
          background-image: url(~@/assets/img/bj@2x.png);
        }
      }
      .firstLevel {
        background-size: 40px 40px;
        background-position: center;
        background-repeat: no-repeat;
      }
      .firstLevel:hover,
      .firstLevel.ant-menu-item-selected {
        background-image: url(~@/assets/img/bj@2x.png);
      }
    }
  }
}
@media screen and(min-width: 1900px) {
  .teacher-menu {
    width: 230px;
    .menu {
      /deep/.ant-menu {
        .ant-menu-item {
          font-size: 16px !important;
        }
        .ant-menu-submenu-title {
          height: 55px;
          line-height: 55px;
        }
      }
      .firstLevel {
        height: 55px;
        line-height: 55px;
      }
      .list {
        .title {
          // height: 40px;
          font-size: 16px;
          .icon-logo {
            width: 16px;
          }
        }
      }
    }
  }
  .logo {
    img {
      width: 80px !important;
    }
  }
}
@media screen and(min-width: 1700px) and (max-width: 1900px) {
  .teacher-menu {
    width: 210px;
    .menu {
      /deep/.ant-menu {
        .ant-menu-item {
          font-size: 16px !important;
        }
        .ant-menu-submenu-title {
          height: 50px;
          line-height: 50px;
        }
      }
      .firstLevel {
        height: 50px;
        line-height: 50px;
      }
      .list {
        .title {
          // height: 40px;
          font-size: 16px;
          .icon-logo {
            width: 16px;
          }
        }
      }
    }
  }
  .logo {
    img {
      width: 80px !important;
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px) {
  .teacher-menu {
    width: 164px;
    .menu {
      padding-left: 0;
      /deep/.ant-menu {
        .ant-menu-submenu-title {
          height: 45px;
          line-height: 45px;
        }
      }
      .firstLevel {
        height: 45px;
        line-height: 45px;
      }
      .list {
        .title {
          // height: 40px;
          font-size: 14px;
          padding: 12px 32px 12px 26px;
          .icon-logo {
            width: 14px;
          }
          .icon-control {
            right: 15px;
          }
        }
      }
    }
  }
}
@media screen and(min-width: 1300px) and (max-width: 1500px) {
  .teacher-menu {
    width: 164px;
    .menu {
      padding-left: 10px;
      /deep/.ant-menu {
        .ant-menu-submenu-title {
          height: 45px;
          line-height: 45px;
        }
      }
      .firstLevel {
        height: 45px;
        line-height: 45px;
      }
      .list {
        .title {
          // height: 40px;
          font-size: 14px;
          padding: 12px 32px 12px 26px;
          .icon-logo {
            width: 14px;
          }
          .icon-control {
            right: 12px;
          }
        }
      }
    }
  }
  .admin-menu {
    .menu {
      padding-left: 0;
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px) {
  .teacher-menu {
    width: 164px;
    .menu {
      padding-left: 0;
      /deep/.ant-menu {
        .ant-menu-submenu-title {
          height: 45px;
          line-height: 45px;
        }
      }
      .firstLevel {
        height: 45px;
        line-height: 45px;
      }
      .list {
        .title {
          // height: 40px;
          font-size: 14px;
          padding: 12px 32px 12px 22px;
          .icon-logo {
            width: 14px;
          }
          .icon-control {
            right: 12px;
          }
        }
      }
    }
  }
  .admin-menu {
    .menu {
      padding-left: 0;
    }
  }
}
@media screen and (max-width: 1200px) {
  .teacher-menu {
    width: 140px;
    .menu {
      padding-left: 0;
      /deep/.ant-menu {
        .ant-menu-item {
          font-size: 12px !important;
        }
        .ant-menu-submenu-title {
          height: 40px;
          line-height: 40px;
          font-size: 12px !important;
        }
      }
      .firstLevel {
        height: 40px;
        line-height: 45px;
      }
      .list {
        .title {
          // height: 40px;
          font-size: 14px;
          padding: 12px 32px 12px 22px;
          .icon-logo {
            width: 14px;
          }
          .icon-control {
            right: 12px;
          }
        }
      }
    }
  }
  .admin-menu {
    .menu {
      padding-left: 0;
    }
  }
}
/deep/ .secondLevel {
  .ant-menu-submenu-title {
    padding-left: 20px !important;
  }
  .ant-menu-item {
    padding-left: 40px !important;
  }
}
/deep/ .secondTitle {
  padding-left: 27px;
  font-size: 14px;
  color: #fff;
}
</style>

<style lang="less">
.l-tooltip {
  .ant-tooltip-inner {
    padding: 4px 0px 4px 0px;
  }
  .ant-tooltip-arrow {
    display: none;
  }
}
.l-menu-tooltip {
  .content {
    width: 160px;
    .selected {
      background-color: #ffa000;
    }
  }
  .item {
    width: 160px;
    height: 40px;
    line-height: 40px;
    margin: 2px 0px 0px 0px;
    padding: 0px 16px;
    box-sizing: border-box;
  }
}
.ant-menu-submenu-popup .secondTitle {
  padding-left: 0px;
}
.ant-menu-submenu-popup .ant-menu .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: #ffa000 !important;
  color: #fff;
}
</style>
